module.exports = "abc"


/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/raw-loader!./loaders/_resources/abc.txt
 ** module id = 4
 ** module chunks = 0
 **/